import createReducer from './createReducer';
import * as actions from '../actions/actionTypes';
import { isNil, mergeAll } from 'ramda';
import { MarketCodes } from "../marketCodes";
import { LandingCodes } from "../landingCodes";

const marketCodePageNames = [
  { siteSection: "PRE-APPLY", marketCode: "open-market", pageName: "OM:PRE-APPLY:HOME" },
  { siteSection: "PRE-APPLY", marketCode: "direct-mailer", pageName: "PRE-APPLY:INVITE_CODE" },
  { siteSection: "PRE-APPLY", marketCode: "bank-market", pageName: "CL:APPLY:RATE" },
  { siteSection: "PRE-APPLY", marketCode: "direct-mailer", landingCode: LandingCodes.AADVANTAGE, pageName: "PRE-APPLY:INVITE_CODE:AA" },
  { siteSection: "RATE", marketCode: "open-market", pageName: "OM:SOFTPULL:RATE" },
  { siteSection: "RATE", marketCode: "direct-mailer", pageName: "SOFTPULL:RATE" },
  { siteSection: "RATE", marketCode: "bank-market", pageName: "CL:APPLY:RATE" },
  { siteSection: "RATE", marketCode: "direct-mailer", landingCode: LandingCodes.AADVANTAGE, pageName: "SOFTPULL:RATE" },
  { siteSection: "TERM", marketCode: "open-market", pageName: "OM:SOFTPULL:TERM" },
  { siteSection: "TERM", marketCode: "direct-mailer", pageName: "PRE-APPLY:SOFTPULL:TERM" },
  { siteSection: "TERM", marketCode: "bank-market", pageName: "CL:APPLY:TERM" },
  { siteSection: "TERM", marketCode: "direct-mailer", landingCode: LandingCodes.AADVANTAGE, pageName: "PRE-APPLY:SOFTPULL:TERM" },
  { siteSection: "APPLICATION", marketCode: "open-market", pageName: "OM:SOFTPULL:APPLICATION" },
  { siteSection: "APPLICATION", marketCode: "direct-mailer", pageName: "SOFTPULL:APPLICATION" },
  { siteSection: "APPLICATION", marketCode: "bank-market", pageName: "CL:APPLY:APPLICATION" },
  { siteSection: "APPLICATION", marketCode: "lending-tree", pageName: "CL:APPLY:APPLICATION" },
  { siteSection: "APPLICATION", marketCode: "credit-karma", pageName: "CL:APPLY:APPLICATION" },
  { siteSection: "APPLICATION", marketCode: "direct-mailer", landingCode: LandingCodes.AADVANTAGE, pageName: "SOFTPULL:APPLICATION" }
];

const getPageNameByMarketCodeAndPageStep = (marketCode, siteSection, landingCode) => {
  let filter = null;
  if (!isNil(siteSection) && !isNil(marketCode)) {
    if (!isNil(landingCode)) {
      filter = marketCodePageNames.find((result) => {
        return result.marketCode === marketCode && result.siteSection === siteSection && result.landingCode === landingCode;
      });
    }else{
      filter = marketCodePageNames.find((result) => {
        return result.marketCode === marketCode && result.siteSection === siteSection;
      });
    }
    return filter ? filter.pageName : undefined;
  }
  return undefined;
};

const getProductAdvertisementChannel = (marketCode) => {
  if (marketCode === MarketCodes.OPEN_MARKET) {
    return 'OPENMARKET';
  } else if (marketCode === MarketCodes.DIRECT_MAILER) {
    return 'DIRECTMAIL';
  } else if (marketCode === MarketCodes.BANK_MARKET) {
    return 'BANKMARKET';
  } else if (marketCode === MarketCodes.LENDING_TREE) {
    return 'AFFILIATE:LT';
  } else if (marketCode === MarketCodes.CREDIT_KARMA) {
    return 'AFFILIATE:CK';
  }

  return undefined;
};

const dtmReducer = createReducer({}, {

  [actions.PROSPECT_VALIDATED]: (state, action) =>
    mergeAll([
      state,
      {
        campaign_id: action.data.campaign.campaignId,
        campaign_cell_number: action.data.campaign.cellId,
        pageInfo: { pageName: 'SOFTPULL:RATE', siteSection: 'SOFTPULL', landingPageType: 'CL APPLY', partnerCode: 'CLA' }
      }
    ]),

  [actions.APPLICATION_DECISION]: (state, action) => {
    switch (action.applicationDecision.pageId) {
    case 'decline':
      return mergeAll([
        state,
        { 'pageInfo': { 'pageName': 'DECLINED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" }, 'transaction': { 'confirmationId': action.applicationDecision.applicationId }, 'product_decision': action.applicationDecision.applicationStatus }
      ]);

    case 'applicationReference':
      return mergeAll([
        state,
        { 'pageInfo': { 'pageName': 'PENDED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" }, 'transaction': { 'confirmationId': action.applicationDecision.applicationId }, 'product_decision': action.applicationDecision.applicationStatus }
      ]);

    case 'approved':
      return mergeAll([
        state,
        { 'pageInfo': { 'pageName': 'APPROVED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" }, 'transaction': { 'confirmationId': action.applicationDecision.applicationId }, 'product_decision': action.applicationDecision.applicationStatus }
      ]);

    case 'verid':
      return mergeAll([
        state,
        { 'transaction': { 'confirmationId': action.applicationDecision.applicationId }, 'product_decision': action.applicationDecision.applicationStatus }
      ]);

    default:
      return state;
    }
  },

  [actions.QUOTE_RECEIVED]: (state, action) => {
    if (action.quote.status === 'DECLINED') {
      return mergeAll([
        state,
        { 'pageInfo': { 'pageName': 'DECLINED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
      ]);
    } else {
      return state;
    }
  },

  [actions.VERID_QUESTIONS_RECEIVED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': 'VERID_AUTH', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.VERID_QUESTIONS_FETCH_FAILED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': 'PENDED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.APPLICATION_STATUS_FETCH_FAILED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': 'PENDED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.VERID_TIMER_EXPIRED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': 'PENDED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.VERID_ERROR]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': 'PENDED:APPLICATION', 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.LANDING_FORM_SUBMITTED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': getPageNameByMarketCodeAndPageStep(state.marketCode, 'RATE', state.landingCode), 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.CHECK_YOUR_RATE_FORM_SUBMITTED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': getPageNameByMarketCodeAndPageStep(state.marketCode, 'TERM', state.landingCode), 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.SELECT_OFFER_FORM_SUBMITTED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': getPageNameByMarketCodeAndPageStep(state.marketCode, 'APPLICATION', state.landingCode), 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.LOAN_APPLICATION_RECEIVED]: (state, action) =>
    mergeAll([
      state,
      { 'pageInfo': { 'pageName': getPageNameByMarketCodeAndPageStep(state.marketCode, 'APPLICATION', state.landingCode), 'siteSection': 'APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" } }
    ]),

  [actions.FIRE_DTM_CONTROLLER]: (state, action) => state,

  [actions.MARKET_CODE_CHANGED]: (state, action) =>
    mergeAll([
      state,
      {
        'pageInfo': { 'pageName': getPageNameByMarketCodeAndPageStep(action.data.marketCode, 'PRE-APPLY', state.landingCode), 'siteSection': 'PRE-APPLY', "landingPageType": "CL APPLY", "partnerCode": "CLA" },
        'productInfo': { 'productAdvertisementChannel': getProductAdvertisementChannel(action.data.marketCode) } }
    ])
});

export default dtmReducer;
